import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { tcDaviviendaText } from '@environment/tc-davivienda-text';
import * as moment from 'moment-timezone';
import { TcDavivienda } from '../model/tc-davivienda';
import { TcDaviviendaService } from '../service/tc-davivienda.service';
import { CryptoJSAesDecrypt } from '@cryptoJs/decrypt.service';
import { ServicesJelpitService } from '@services/services-jelpit/services-jelpit.service';

@Component({
  selector: 'app-tc-form',
  templateUrl: './tc-form.component.html',
  styleUrls: ['./tc-form.component.scss'],
  providers: [TcDaviviendaService],
})
export class TcFormComponent implements OnInit {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() typeDocument: any[] = [];
  @Input() typeFunction: string = '';
  @Output() btnContnue = new EventEmitter<string>();
  @Output() nomDocument = new EventEmitter();

  tcForm: FormGroup;
  min: number;
  max: number;
  messageError: string = '';
  messageErrorRequired: string = tcDaviviendaText.messageErrorRequired;
  type: string = '';
  hrefTermAndConditions: string = tcDaviviendaText.hrefTermsAndConditions;
  proceddingPersonalData: string = tcDaviviendaText.proceddingPersonalData;
  validForm: boolean = false;
  submited: boolean = false;
  idTypeDocument: number;
  isMobile: boolean;

  constructor(
    private fb: FormBuilder,
    private service: TcDaviviendaService,
    private decrypt: CryptoJSAesDecrypt,
    private  jelpitService: ServicesJelpitService
  ) {
    this.hrefTermAndConditions = jelpitService.envUrl + this.hrefTermAndConditions;
    this.proceddingPersonalData = jelpitService.envUrl + this.proceddingPersonalData;

    this.tcForm = this.fb.group({
      documentType: new FormControl(
        'Cédula de Ciudadanía',
        Validators.compose([Validators.required])
      ),
      documentNumber: new FormControl('', Validators.required),
      policyTerms: new FormControl('', [Validators.required]),
    });
    this.tcForm.get('documentNumber').disable();
    this.tcForm.get('documentNumber').updateValueAndValidity();
    this.selectedTypeDocument('Cédula de Ciudadanía');
    if (this.validateMobileOrDesk()) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  validateMobileOrDesk() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      return toMatchItem.exec(navigator.userAgent);
    });
  }

  ngOnInit() {
    this.tcForm.valueChanges.subscribe((response) => {
      this.submited = false;
      this.validForm = this.tcForm.valid;
    });
    this.tcForm.get('policyTerms').valueChanges.subscribe((val) => {
      if (!val && val !== '') {
        this.tcForm.get('policyTerms').setValue('');
        this.tcForm.get('policyTerms').updateValueAndValidity();
      }
    });
    this.tcForm.get('documentNumber').valueChanges.subscribe((val) => {
      if (this.type === 'number') {
        if (val !== '' && val) {
          if (val.includes('.') || val.includes(' ')) {
            let newVal;
            if (val.includes('.')) {
              newVal = val.replaceAll('.', '');
            } else {
              newVal = val.replaceAll(' ', '');
            }
            this.tcForm.get('documentNumber').setValue(newVal);
          }
        }
      }
    });
  }

  setEventClick() {
    this.submited = true;
    if (this.validForm) {
      const typeDoc = tcDaviviendaText.tcDaviviendaTypesDocuments.filter(
        (res) => res.name === this.tcForm.get('documentType').value
      )[0];
      const data: TcDavivienda = {
        document_type: typeDoc.id.toString(),
        document_number: this.tcForm.get('documentNumber').value,

      };
      this.nomDocument.emit(data.document_number);
      this.service.consultUser(data)
        .subscribe({
          next: (res) => {
            let status = "";
            let active = false;
            let inactive = false;
            let serviceResponse;
            let data = {
              name: "",
              assistances: [],
              date: moment().tz('America/Bogota').format(),
              data: {
                document_type: typeDoc.id.toString(),
                document_number: this.tcForm.get('documentNumber').value,
              }
            };
            if (res.result.value) {
              serviceResponse = JSON.parse(this.decrypt.cryptoJSAesDecrypt(res.result.value));
              data = {
                name: serviceResponse.name,
                assistances: serviceResponse.assistances,
                date: moment().tz('America/Bogota').format(),
                data: {
                  document_type: typeDoc.id.toString(),
                  document_number: this.tcForm.get('documentNumber').value,
                }
              };
              [active, inactive] = this.checkCardsStatus(data.assistances);

            }
            if (active) {
              status = 'ACTIVO';
            } else if (inactive) {
              status = 'INACTIVO'
            }
            localStorage.setItem('userSesionTC', JSON.stringify(data));
            this.resetForm();
            this.btnContnue.emit(status);
          },
          error: (errorResponse) => {
            if (errorResponse?.error) {
              if (
                errorResponse?.error.messages ===
                tcDaviviendaText.errorNotRegister
              ) {
                const data = {
                  name: '',
                  service: [],
                  status: 'noExistingTC',
                  date: moment().tz('America/Bogota').format(),
                  data: {
                    document_type: typeDoc.id.toString(),
                    document_number: this.tcForm.get('documentNumber').value,
                  }
                };
                localStorage.setItem('userSesionTC', JSON.stringify(data));
                this.resetForm();
                this.btnContnue.emit('noExistingTC');
              }
            }
          },
        });
    }

  }


  resetForm() {
    this.tcForm.get('policyTerms').setValue('');
    this.tcForm.get('documentNumber').setValue('');
    this.selectedTypeDocument('Cédula de Ciudadanía');
  }

  selectedTypeDocument(value: string) {
    this.tcForm.get('documentNumber').enable();
    this.tcForm.get('documentNumber').setValue('');
    this.tcForm.get('documentNumber').clearValidators();


    switch (value) {
      case 'Cédula de Ciudadanía':
        this.min = tcDaviviendaText.tcDaviviendaDocuments.CC.min;
        this.max = tcDaviviendaText.tcDaviviendaDocuments.CC.max;
        this.tcForm
          .get('documentNumber')
          .setValidators([
            Validators.required,
            Validators.minLength(this.min),
            Validators.maxLength(this.max),
            Validators.pattern(/^-?(0|^[1-9]\d*)?$/),
          ]);
        this.messageError =
          tcDaviviendaText.tcDaviviendaDocuments.CC.messageError;
        this.type = tcDaviviendaText.tcDaviviendaDocuments.CC.type;
        this.tcForm.get('documentNumber').enable();
        this.tcForm.get('documentNumber').updateValueAndValidity();
        break;
      case 'Cédula de Extranjería':
        this.min = tcDaviviendaText.tcDaviviendaDocuments.CE.min;
        this.max = tcDaviviendaText.tcDaviviendaDocuments.CE.max;
        this.tcForm
          .get('documentNumber')
          .setValidators([
            Validators.required,
            Validators.minLength(this.min),
            Validators.maxLength(this.max),
            Validators.pattern(/^-?(0|^[1-9]\d*)?$/),
          ]);
        this.messageError =
          tcDaviviendaText.tcDaviviendaDocuments.CE.messageError;
        this.type = tcDaviviendaText.tcDaviviendaDocuments.CE.type;
        this.tcForm.get('documentNumber').updateValueAndValidity();
        break;
      case 'Pasaporte':
        this.min = tcDaviviendaText.tcDaviviendaDocuments.PP.min;
        this.tcForm
          .get('documentNumber')
          .setValidators([
            Validators.required,
            Validators.minLength(this.min),
            Validators.pattern('^[A-Za-z0-9_-]*$'),
          ]);
        this.messageError =
          tcDaviviendaText.tcDaviviendaDocuments.PP.messageError;
        this.type = tcDaviviendaText.tcDaviviendaDocuments.PP.type;
        this.tcForm.get('documentNumber').enable();
        this.tcForm.get('documentNumber').updateValueAndValidity();
        break;
      default:
        this.tcForm.get('documentNumber').disable();
        break;
    }
    this.tcForm.updateValueAndValidity();
  }

  /**Este metodo valida el simbolo + para reemplazarlo de la cadena */
  valdiateSimbol(event) {
    let charCode = event.keyCode || event.which;
    if (this.type == "number") {
      if (charCode == 46 || charCode == 101) {
        return false;
      }
    }
    if (charCode == 43 || charCode == 45) {
      return false
    }
  }


  /**Este metodo valida el simbolo + para reemplazarlo de la cadena */
  valdiateSimbolChange() {
    let value = this.tcForm.get('documentNumber').value.split("+").join("").split("-").join("").split(".").join("");
    this.tcForm.get('documentNumber').setValue(value);

  }

  /**
   * The function `checkCardsStatus` checks the status of assistances and returns an array indicating
   * if there are active or inactive assistances.
   * @param assistances - The `checkCardsStatus` function is designed to check the status
   * of a list of assistances. The function iterates through each assistance in the provided array and
   * sets flags for active and inactive statuses based on the `status` property of each assistance
   * object.
   * @returns An array containing two boolean values - the first value indicates if there is at least
   * one assistance with status 'ACTIVO' (true if there is, false if there isn't), and the second value
   * indicates if there is at least one assistance with a status other than 'ACTIVO' (true if there is,
   * false if there isn't).
   */
  checkCardsStatus(assistances){
    let active = false;
    let inactive = false;
    assistances.forEach(assistance => {
      if (assistance.status === 'ACTIVO') {
        active = true;
      } else {
        inactive = true;
      }
    });
    return [active, inactive];
  }

}
